<script setup lang="ts">
import { ElIcon } from 'element-plus'

import ArrowIcon from '../../../../assets/icons/arrow.svg?component'
defineProps<{
  visible: boolean
  hasPrevItem?: boolean
  hasNextItem?: boolean
}>()
const emits = defineEmits<(event: 'navigate', direction: 'prev' | 'next') => void>()
</script>
<template>
  <Teleport to="body">
    <div v-if="visible" class="content-item-details__nav">
      <button
        type="button"
        class="content-item-details__nav-button content-item-details__nav-button--prev"
        :disabled="!hasPrevItem"
        aria-label="Previous content item"
        @click="emits('navigate', 'prev')"
      >
        <ElIcon :size="24">
          <ArrowIcon />
        </ElIcon>
      </button>
      <button
        type="button"
        class="content-item-details__nav-button content-item-details__nav-button--next"
        :disabled="!hasNextItem"
        aria-label="Next content item"
        @click="emits('navigate', 'next')"
      >
        <ElIcon :size="24">
          <ArrowIcon style="transform: rotate(180deg)" />
        </ElIcon>
      </button>
    </div>
  </Teleport>
</template>
<style scoped lang="scss">
.content-item-details__nav {
  position: fixed;
  inset: 0;
  z-index: 10001;
  pointer-events: none;
}
.content-item-details__nav-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: var(--inverted);
  color: var(--primary);
  box-shadow: 0 2px 8px rgba(34, 34, 34, 0.16);
  cursor: pointer;
  transition: background var(--transition) ease;
  &:hover:not(:disabled) {
    background: var(--secondary-12);
  }
  &--prev {
    left: 20px;
  }
  &--next {
    right: 20px;
  }
  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
}
</style>
